import React from "react";
import { useModal } from "hooks";
import locale from "localization";
import styles from "./add-voucher-campaign.module.scss";
import { FormMode } from "enums";
import { Path } from "enums";
import { Intro, BackLink } from "components/commons";
import VoucherDetailsModule from "../voucher-campaign-details/voucher-campaign-details.module";

const AddVoucherCampaign = () => {
  const successModal = useModal();

  return (
    <div>
      <BackLink text={locale.voucherCampaigns} path={Path.Campaigns} />
      <div className={styles.intro}>
        <Intro title={locale.createVoucherCampaign} />
        <VoucherDetailsModule pageMode={FormMode.Add} {...successModal} />
      </div>
    </div>
  );
};

export default AddVoucherCampaign;
